import { render, staticRenderFns } from "./dragFormCard.vue?vue&type=template&id=2e663cb6&"
import script from "./dragFormCard.vue?vue&type=script&lang=js&"
export * from "./dragFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports